require('./depositMoneyFinalStep.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
// @ commons
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const WizardError = require('components/commons/wizardError/wizardError');
// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ helpers
const { getFormattedString, formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

class DepositMoneyFinalStep extends React.Component {
    constructor(props) {
        super(props);

        this.buildSuccess = this.buildSuccess.bind(this);
        this.buildError = this.buildError.bind(this);
    }

    buildError() {
        const { error, immCard } = this.props;
        const errorTitle = formatText('cardDepositMoney-errorTitle');
        const goBackButtonLabel = formatText('cardDepositMoney-backToCard', [immCard.getIn(['alias', 'current'])]).toUpperCase();
        const linkToDetails = `/myprofile/cards/${immCard.get('cardId')}/details`;
        // const errorDesc = formatTextWithDefaultMessage(`cardAPIErrors-${error}`, [], 'cardDepositMoney-errorMessage')
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };

        return (
            <WizardError
                errorMessage={errorTitle}
                mainButton={mainButton}>
                <section className="deposit-money-final__content row">
                    <div className="col-xs-5">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                    </div>
                    <div className="col-xs-7">
                        <FormattedText
                            defaultMessageCode="cardDepositMoney-errorMessage"
                            value={`cardAPIErrors-${error}`}
                        />
                        {/* <span>{errorDesc}</span> */}
                    </div>
                </section>
            </WizardError>
        );
    }

    buildSuccess() {
        const { immCard, immStep } = this.props;
        const amount = immStep.get('amount');
        const cardAlias = immCard.get('alias').get('current');
        const goBackButtonLabel = formatText('cardDepositMoney-backToCard', [cardAlias]).toUpperCase();
        const linkToDetails = `/myprofile/cards/${immCard.get('cardId')}/details`;
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };
        const newAvailableBalanceObj = {
            amount: parseFloat(immCard.get('availableBalance').get('amount')) + parseFloat(amount),
            currency: immCard.get('availableBalance').get('currency')
        };
        const amountObject = {
            amount,
            currency: immCard.get('availableBalance').get('currency')
        };
        const amountLabel = getFormattedString(amountObject);
        const successTitle = immCard.get('isViaT') ? formatText('cardDepositMoney-successfullyPaidViaT', [amountLabel]): formatText('cardDepositMoney-successfullyPaid', [amountLabel]);
        const plainAmountObject = getPlainAmountObject(newAvailableBalanceObj);

        return (
            <WizardSuccess
                successMessage={successTitle}
                mainButton={goBackButton}>
                <section className="deposit-money-final__content row">
                    <div className="col-xs-6 col-md-7">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                    </div>
                    <div className="col-xs-6 col-md-5">
                        <FormattedText
                            value="cardDepositMoney-newAvailableBalance"
                            className="deposit-money-final__new-available-balance"
                        />
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </div>
                </section>
            </WizardSuccess>
        );
    }

    render() {
        let finalBlock;

        if (!this.props.errorState) {
            finalBlock = this.buildSuccess();
        } else {
            finalBlock = this.buildError();
        }

        return (
            <article className="deposit-money-final">
                {finalBlock}
            </article>
        )
    }
}

DepositMoneyFinalStep.propTypes = {
    error: PropTypes.string,
    immCard: PropTypes.object,
    immStep: PropTypes.object,
    errorState: PropTypes.bool
};

module.exports = DepositMoneyFinalStep;